/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { defineResource } from 'pulse/resources';
import { fromRPC } from 'pulse/adapters';
import * as References from './AttachmentsRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});

// RPC Resources

export const GetUploadTokenRpc = defineResource({
  typeName: 'com.hubspot.support.portal.rpc.AttachmentsRpc.getUploadToken',
  args: ['params', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  resolver: fromRPC({
    rpc: References.getUploadTokenRpc,
    rpcClient: chirpClient
  })
}).register();
export const GetThreadAttachmentsRpc = defineResource({
  typeName: 'com.hubspot.support.portal.rpc.AttachmentsRpc.getThreadAttachments',
  args: ['params', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  resolver: fromRPC({
    rpc: References.getThreadAttachmentsRpc,
    rpcClient: chirpClient
  })
}).register();